<template>
  <v-app>
    <v-app-bar app dense dark flat v-if="!$route.path.includes('/auth/')">
      <v-toolbar-title class="headline">
        <v-icon>mdi-home</v-icon>
        <span>Scottsdale BeachFest</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
              outlined
              v-if="loggedIn"
              @click="$store.dispatch('signout')"
      >
        <v-icon>mdi-location-exit</v-icon>
      </v-btn>

      <BaseBtn
              text
              v-else
              to="/auth/signin"
      >
        Sign In
      </BaseBtn>
      <BaseBtn
              v-if="!loggedIn"
              to="/auth/signup"
      >
        Sign Up
      </BaseBtn>

    </v-app-bar>

    <RouterView />

    <Footer />

    <Snackbar />

  </v-app>
</template>

<script>
import {
  mapActions
} from 'vuex'
import Snackbar from "@/components/Snackbar";
import BaseBtn from "@/components/BaseBtn";
import Footer from "@/components/Footer";


export default {
  name: 'App',
  components: {
    BaseBtn,
    Snackbar,
  },
  computed:{
    loggedIn(){
      return this.$store.getters['cognito/isLoggedIn'];
    },
    isReady(){
      return this.$store.state.isReady;
    }
  },
  watch:{
    loggedIn(n,o){
      if(n && this.$route.path.includes('auth')){
        this.$router.push('/')
      }
      if(n){
        this.$store.dispatch('refreshAuth')
      }
    }
  },
  data: () => ({
    drawer:false,
    versiondialog:false,
    w:'',
    version:'1.2.25',
    orgdialog:false,
    activeorg:false,
    loading:false,
    registrationdialog:false,
    registration: null,
    printdata:undefined
  }),
  async mounted(){
    let em = this
    this.getEvents()
  },
  methods:{
    ...mapActions(['getEvents']),
    showOffline(){
      console.log('Offline')
    },
    showRefreshUI (e) {
      this.$store.commit('setNewContent',true)
      // My code to show the refresh UI banner/snackbar goes here.
    },
    refreshGo(){


    },
    checkVersion(){
      let em = this;
      let headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      };
      let args = {
        headers:headers,
        method:'get'
      };
      fetch(this.$store.state.url+'versionv2/textappy2',args)
              .then((response) => response.json())
              .then((response) => {
                em.$store.commit('setVersion',response.string)
              })
    },

    loadOrg(item){
      if(this.$store.state.org.partkey!==item.partkey){
        this.activeorg=item
        this.orgdialog=true
      } else {
        this.$router.push('/account')
      }
    },
    confirmLoadOrg(){
      //sets the 'default o new org, then loads default
      let args;
      let em = this;
      em.loading=true;
      args = {
        url:this.$store.state.url + 'api/orgs/setdefault',
        method:"POST",
        data:{
          orgkey:this.activeorg.partkey
        }
      }
      this.$store.dispatch('fetch',args).then(data=>{
        em.$store.dispatch('getAppData')
        em.loading=false
        em.activeorg=false
        em.orgdialog=false
        em.$router.push('/account')
      })
    }
  },
  beforeDestroy () {
    document.removeEventListener('swUpdated', this.showRefreshUI);
  },
};
</script>
